<template lang="pug">
  .google-map
    // Search box
    GoogleMapSearchBox(v-if="searchBar", @placesChanged="panToPosition", :embeddedOnMap="true")
    // This will be replaced by the map
    .placeholder(:id='this._uid')
    // This will be used to wire map compopnents
    slot
    // Marker to pin search results
    google-map-marker(v-if='search_marker',:key='search_marker.title',:position="search_marker.position",:title='search_marker.title',:label='search_marker.label')
</template>

<script type="text/babel">
  import GoogleMapMarker from './GoogleMapMarker.vue'
  import GoogleMapSearchBox from './GoogleMapSearchBox'

  export default {
    name: 'GoogleMap',
    data() {
      return {
        map: null,
        search_marker: null,
      }
    },
    components: {
      GoogleMapSearchBox,
      GoogleMapMarker
    },
    mounted() {
      if (!this.ready) {
        this.createGoogleMaps()
          .then(this.initGoogleMaps, this.googleMapsFailedToLoad)
      }
    },
    methods: {
      createGoogleMaps: function () {
        var self = this
        return new Promise((resolve, reject) => {
          if (document.getElementById('google-map-loader') === null) {
            let gmap = document.createElement('script')
            gmap.setAttribute('id', 'google-map-loader')
            gmap.src = self.url
            gmap.type = 'text/javascript'
            gmap.onload = resolve
            gmap.onerror = reject
            document.body.appendChild(gmap)
          } else {
            resolve()
          }

        })
      },
      googleMapsFailedToLoad: function () {
        alert('Google maps failed to load!')
      },
      initGoogleMaps: function () {
        this.map = new google.maps.Map(document.getElementById(this._uid), {
          zoom: this.zoom,
          center: this.center,
          mapTypeId: this.mapTypeId,
          scrollwheel: this.scrollWheelZoom,
          styles: this.mapStyle,
          // Buttons
          zoomControl: this.zoomControl,
          scaleControl: false,
          clickableIcons: false,
          streetViewControl: false,
          // Disabled:
          fullscreenControl: false,
          disableDefaultUI: true,
          mapTypeControl: this.mapTypeControl,
          draggable: this.draggable,
          panControl: this.panControl,
        })

        this.$emit('map-ready')


        if (this.listenForClick) {
          this.map.addListener('click', (e) => {
            if (this.search_marker) {
              this.search_marker = false
            }
            this.$emit('mapClicked', e.latLng)
          })
        }
      },
      panToPosition(place) {
        this.pan(place.geometry.location.lat(), place.geometry.location.lng())

        this.search_marker = {
          position: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          },
          title: place.formatted_address,
          label: '',
        }
      },
      getMap: function () {
        return this.map
      },
      pan: function (lat, lng) {
        if (this.map) {
          this.map.panTo(new google.maps.LatLng(lat, lng))
        }
      },
      getBounds(markers, centerPoint) {
        if (this.ready) {
          var bounds = new google.maps.LatLngBounds()
          bounds.extend(new google.maps.LatLng(centerPoint.lat, centerPoint.lng))
          var c = 2
          for (var i = 0; i < c; i++) {
            if (markers[i].position) {
              bounds.extend(new google.maps.LatLng(markers[i].position.lat, markers[i].position.lng))
            }
          }
          this.map.fitBounds(bounds)
        }
      }
    },
    computed: {
      ready: function () {
        return this.map != null
      },
      url: function () {
        const libraries = this.libraries.join(',')
        return this.proxyUrl && this.proxyUrl !== '' ? this.proxyUrl : `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=${libraries}`
      }
    },
    props: {
      apiKey: {
        type: String
      },
      mapTypeId: {
        type: String,
        default: 'roadmap'
      },
      center: {
        type: Object
      },
      //  0: Earth fully zoomed out
      //  1: World
      //  5: Landmass/continent
      // 10: City
      // 15: Streets
      // 20: Buildings
      zoom: {
        type: Number,
        default: 13
      },
      scrollWheelZoom: {
        type: Boolean,
        default: true
      },
      searchBar: {
        type: Boolean,
        default: false
      },
      mapStyle: {
        type: Array,
        default: null
      },
      draggable: {
        type: Boolean,
        default: true
      },
      panControl: {
        type: Boolean,
        default: true
      },
      proxyUrl: {
        type: String
      },
      libraries: {
        type: Array,
        default: () => {
          return [
            'places',
            'visualization',
          ]
        }
      },
      listenForClick: {
        type: Boolean,
        default: false
      },
      zoomControl: {
        type: Boolean,
        default: false
      },
      mapTypeControl: {
        type: Boolean,
        default: false
      },
    }
  }
</script>

<style lang="sass">
  .google-map
    position: relative
    width: 100%
    height: 100%

    .controls
      margin-top: 10px
      width: 250px
      height: 32px

    .placeholder
      width: 100%
      height: 100%
      position: absolute
</style>



// WEBPACK FOOTER //
// GoogleMap.vue?58e9d4ec